import { useEffect, useState } from 'react';
import { calendarStateDeterminer } from '../../../../../ui-kitchen/src/utils';
import { reduceInventory, assessSoldOut, reduceInventoryAmex } from './venueDetailsUtils';
// useVenueInventoryState Custom Hook
//
// Parses venueInventory data into venueInventoryState, updates when venueInventory data does
// Returns venueInventoryState
const useVenueInventoryState = ({
  venueInventoryData, isVenueInventoryLoading, venueInventoryKey, selectedISODate,
  filterReservationsByDate, experientialDateLimit,
}) => {
  const [venueInventoryState, setVenueInventoryState] = useState({
    inventoryByDay: {},
    isVenueClosed: false,
    soldOut: null,
    venueInventory: {},
  });
  useEffect(() => {
    /* istanbul ignore else */
    if (!isVenueInventoryLoading && venueInventoryKey !== '') {
      // eslint-disable-next-line camelcase
      const { scheduled, last_calendar_day } = venueInventoryData;
      const nextState = {};
      if (scheduled && scheduled.length > 0) {
        const scheduledWithStates = scheduled.map((item) => {
          const state = calendarStateDeterminer(
            item.inventory.reservation,
            item.inventory.event
          );
          return { ...item, state };
        });
        nextState.venueInventory = {
          scheduled: scheduledWithStates,
          last_calendar_day,
        };
        if (filterReservationsByDate && experientialDateLimit?.enabled) {
          const { start_date: startDate, end_date: endDate } = experientialDateLimit;
          nextState.inventoryByDay = reduceInventoryAmex(scheduled, startDate, endDate);
        } else {
          nextState.inventoryByDay = reduceInventory(venueInventoryData);
        }
        nextState.soldOut = assessSoldOut(selectedISODate, scheduled);
      } else {
        nextState.isVenueClosed = true;
      }
      setVenueInventoryState((state) => ({ ...state, ...nextState }));
    }
  }, [venueInventoryData, isVenueInventoryLoading, venueInventoryKey, selectedISODate, experientialDateLimit]);
  return venueInventoryState;
};

export default useVenueInventoryState;
